module.exports = __webpack_public_path__ + "Tail_feathers_MetalRoughness.9e236c2.basis";